import Vue from "vue"
import Vuex from "vuex"
import createPersistedState from "vuex-persistedstate";

import actions from "./actions"
import mutations from "./mutations"
import getters from "./getters"
import {initialState} from "./initial"

Vue.use(Vuex)

export default new Vuex.Store({
  state: initialState(),
  plugins: [createPersistedState({
      paths: [
        "muted",
        // "firstLoad"
      ]
  })],
  mutations,
  actions,
  getters
})
